module.exports = __webpack_public_path__ + "media/islands.5c583bbc.png";